import { Header } from "@components:Header";
import { SwitchPage } from "@components:SwitchPage";
import { BotSelectionPersistent } from "@modules:BotSelection/BotSelection";
import { Box } from "@mui/material";
import { ChatBox } from "@pages:app/talk/Chat/components/ChatBox";
import { Landing } from "@pages:app/talk/Chat/components/Landing";
import { Loading } from "@pages:app/talk/Chat/components/Loading";
import { MessageView } from "@pages:app/talk/Chat/components/message-view/MessageView";
import {
  useGenerateChatMessages,
  useSyncConversationTitle,
} from "@pages:app/talk/Chat/hooks";
import { isNotEmptyArray } from "@utils:array";
import { useMemo } from "react";
import { useParams } from "react-router";

import { AppType } from "@:constants";

export const Chat = () => {
  const { conversationId } = useParams();
  const { data: messagesTree, isLoading } = useGenerateChatMessages(
    conversationId ?? "",
  );
  useSyncConversationTitle(conversationId);

  const renderChat = useMemo(() => {
    if (isLoading) return <Loading />;
    if (isNotEmptyArray(messagesTree))
      return <MessageView messagesTree={messagesTree} />;
    return <Landing />;
  }, [isLoading, messagesTree]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        borderRadius: "30px",
        background: (theme) => theme.palette.common.white,
        flex: 1,
        height: "100%",
      }}
    >
      <Header
        sx={{
          background: (theme) => theme.palette.common.white,
          borderTopLeftRadius: "30px",
          borderTopRightRadius: "30px",
        }}
        rightSide={
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box sx={{ paddingX: "0.5rem" }}>
              <BotSelectionPersistent app={AppType.Search} />
            </Box>
            <SwitchPage />
          </Box>
        }
      />
      <Box
        sx={{
          flex: 1,
          height: "100%",
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            width: "0.5rem",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(0,0,0,0.2)",
            borderRadius: "0.25rem",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "rgba(0,0,0,0.3)",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "transparent",
          },
        }}
      >
        {renderChat}
      </Box>
      <Box
        sx={{
          marginBottom: "2rem",
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <ChatBox />
      </Box>
    </Box>
  );
};
